import { render, staticRenderFns } from "./JobListPreview.vue?vue&type=template&id=64b2ba42&"
import script from "./JobListPreview.vue?vue&type=script&lang=js&"
export * from "./JobListPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports